import { ContactPage } from '../Contact'

export const CommunalMachineRentPage = ContactPage